import type { CoreSessionConfig } from '@zhiyue/core';

const THEME_STORAGE_KEY = 'app_nav_theme';

/** Keep appearance in storage: a partial initialState makes Core skip session bootstrap. */
export function getSessionAppearanceConfig(): Pick<
  CoreSessionConfig,
  'storageKeys'
> {
  try {
    const preference = localStorage.getItem(THEME_STORAGE_KEY);
    if (preference !== 'light' && preference !== 'realDark') {
      localStorage.setItem(THEME_STORAGE_KEY, 'realDark');
    }
  } catch {
    // Storage availability is handled by the session provider.
  }
  return { storageKeys: { navTheme: THEME_STORAGE_KEY } };
}
